<portal-modal-header (onClose)="dismiss()">
  <span class="d-inline-block mb-0">{{ 'myNotifications.dialogTitle' | translate }}</span>
  <small class="badge text-bg-secondary ms-1">{{ allItems().length }}</small>
</portal-modal-header>

<portal-modal-body>
  <portal-errors [errors]="[error(), state.error()]"></portal-errors>

  <portal-loading-indicator-container [loading]="loading()" [onlyInitial]="true">
    <portal-filter-input
      class="d-block mb-2"
      [calculateMetaData]="calculateMetaData"
      [entries]="allItems()"
      [properties]="metaDataProperties"
      (changed)="setItems($event)"
    ></portal-filter-input>

    <portal-paged-list-sorter
      class="d-block mb-3"
      [pagedList]="pagedList.instance"
      [properties]="sortProperties"
    />

    @if (pagedList.empty()) {
      <div class="notification-item--empty">
        <img alt="Empty clipboards" height="100" ngSrc="assets/images/no-data.svg" width="96" />

        <span>{{ 'myNotifications.none' | translate }}</span>
      </div>
    }

    <div ngbAccordion>
      @if (pagedList.empty() === false && pagedList.emptyPage()) {
        <div class="notification-item--empty">
          <img alt="Empty clipboards" height="100" ngSrc="assets/images/no-data.svg" width="96" />

          <span>{{ 'myNotifications.allFiltered' | translate }}</span>
        </div>
      }

      @for (notification of pagedList.items(); track notification.id) {
        <div (shown)="markAsSeen(notification)" ngbAccordionItem>
          <div ngbAccordionHeader>
            <button class="notification-item" ngbAccordionButton>
              <portal-my-notification-item-header
                [busy]="state.busy()"
                [busyWith]="state.busyWith()"
                [canDelete]="notification.canDelete"
                [notification]="notification"
                (delete)="deleteNotification(notification.id)"
                (markAsSeen)="markAsSeen(notification)"
              />
            </button>
          </div>

          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <portal-notification-live-view
                  [notifications]="[notification]"
                  [showPublicationDate]="false"
                  [showTitle]="false"
                />
              </ng-template>
            </div>
          </div>
        </div>
      }
    </div>
  </portal-loading-indicator-container>
</portal-modal-body>

<portal-modal-footer [closeOnly]="true" (onCancel)="dismiss()"></portal-modal-footer>
